import { Box, CircularProgress, styled } from '@mui/material';

import { SIZES } from '../../assets/constants/constants.ts';
import { LANG } from '../../services/Config.js';

const LoaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'inline' && prop !== 'hasText',
})<{ inline: boolean; hasText: boolean }>(({ theme, inline, hasText }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  flex: 1,
  marginBottom: inline ? 0 : theme.spacing(8),
  flexDirection: hasText ? 'column' : 'row',
  margin: hasText ? 20 : 0,
  minHeight: inline ? 0 : `calc(100vh - ${SIZES.topBar.height.small}px)`,
  [theme.breakpoints.up(SIZES.navigationChange)]: {
    minHeight: inline ? 0 : `calc(100vh - ${SIZES.topBar.height.large}px)`,
  },
}));

const LoaderText = styled('p')(({ theme }) => ({
  display: 'block',
  marginTop: 10,
  marginBottom: 10,
  color: theme.palette.neutral.medium,
}));

interface LoaderProps {
  inline?: boolean;
  colored?: boolean;
  text?: string;
  size?: any;
  customColor?: string;
}

const Loader = ({ inline = false, colored = false, text, size = 30, customColor }: LoaderProps) => {
  const { appStrings } = LANG;

  return (
    <LoaderContainer inline={inline} hasText={!!text}>
      {text ? <LoaderText className="typography-v1-legacy-p3">{text}</LoaderText> : null}
      <CircularProgress
        size={size}
        color={colored ? 'secondary' : 'primary'}
        aria-label={appStrings.LOADING}
        style={customColor ? { color: customColor } : undefined}
      />
    </LoaderContainer>
  );
};

export default Loader;
